import React from 'react';
import ApiFetch from "../components/ApiFetch";

export async function isLoggin(){
    return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/login/status").then((r)=>{
        return r.json().then((json)=>{
            return json
        })
    })
}
export async function isAdmin(){
    return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/login/isAdmin").then((r)=>{
        return r.json().then((json)=>{
            return json
        })
    })
}
export async function login(email,password,dialog,setCallBack){
    return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/login/",{email:email,password:password}).then((r)=>{
        return r.json().then((json)=>{
            if(json.result && json.two_factor_required === false) {
                setCallBack(json)
                return { success: true, requiresTwoFactor: false, data: json }
            } else if(json.two_factor_required) {
                // 2要素認証が必要
                return { 
                    success: false, 
                    requiresTwoFactor: true, 
                    message: json.message,
                    data: json // anti_phishing_prefixが含まれる可能性がある
                }
            } else {
                setCallBack([])
                dialog("エラー",json.errors)
                return { success: false, requiresTwoFactor: false, errors: json.errors }
            }
        })
    })
}
export async function logout(setCallBack){
    return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/logout/").then((r)=>{
        return r.json().then((json)=>{
            setCallBack([])
            return json.login
        })
    })
}
export async function updateRenzoku(flag){
    return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/login/renzoku",{flag:flag})
        .then((r)=>r.json().then((json)=>{
        return json
    }))
}
export async function updateTile(flag){
    return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/login/tile",{flag:flag})
        .then((r)=>r.json().then((json)=>{
        return json
    }))
}

// 2要素認証コード検証
export async function verifyTwoFactorCode(code) {
    return await new ApiFetch().post(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/login/two-factor-auth", { code: code }).then((r) => {
        return r.json().then((json) => {
            return json
        })
    })
}

// 2要素認証コード再送信
export async function resendTwoFactorCode() {
    return await new ApiFetch().post(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/login/resend-code", {}).then((r) => {
        return r.json().then((json) => {
            return json
        })
    })
}

// フィッシング防止用英語2文字を取得
export async function getAntiPhishingPrefix() {
    return await new ApiFetch().post(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/login/anti-phishing-prefix", {}).then((r) => {
        return r.json().then((json) => {
            return json
        })
    })
}

// 次回送信可能時間を取得
export async function getNextSendTime() {
    return await new ApiFetch().post(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + "/v1/login/next-send-time", {}).then((r) => {
        return r.json().then((json) => {
            return json
        })
    })
}

